const imageContainers = document.querySelectorAll('.product__media-list .product__media-item');
if(imageContainers.length > 1){
    const firstImageContainer = imageContainers[0];
    const originalFirstImage = firstImageContainer.getElementsByTagName('img')[0];
    
    for (let i = 1; i < imageContainers.length; i++) {
        imageContainers[i].addEventListener("mouseover", () => {
            let cloneHoveredImage = imageContainers[i].getElementsByTagName('img')[0].cloneNode()
            originalFirstImage.replaceWith(cloneHoveredImage)
        });
        imageContainers[i].addEventListener("mouseout", () => {
            firstImageContainer.getElementsByTagName('img')[0].replaceWith(originalFirstImage)
        });
    }
}